import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=21beeb95&scoped=true"
import script from "./date-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-input.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./date-input.vue?vue&type=style&index=0&id=21beeb95&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21beeb95",
  null
  
)

export default component.exports